<template>
  <span v-if="!isOwner"
        class="cursor-pointer report"
        :data-balloon="help"
        :data-balloon-pos="tooltipDirection"
        :class="{'report-header': project}"
        tabindex="0"
        @keypress="reportModal"
        @click="reportModal" >
    <i class="fal fa-flag"/>
    <span class="is-hidden-mobile"
          :class="{'is-uppercase' : project}"
          v-if="showText">&nbsp;&nbsp;{{ $t("projectPage.report") }}</span>
  </span>
</template>

<script>
import Modal from './Modal'

import auth from '@/mixins/auth'
import i18n from '@/i18n'

export default {
  components: {
    Modal
  },
  mixins: [auth],
  props: ['project', 'post', 'comment', 'message', 'tooltipDir'],
  methods: {
    reportModal: function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'report', signupMessage: this.body, onSuccess: this.reportModal })
      } else {
        return this.$store.dispatch('showReportModal', { source: 'report', type: this.reportType, id: this.reportID })
      }
    }
  },
  computed: {
    reportObject: function () {
      return this.project || this.post || this.comment || this.message
    },
    reportType: function () {
      if (this.project) {
        return 'content'
      } else if (this.post) {
        return 'post'
      } else if (this.comment) {
        return 'comment'
      } else if (this.message) {
        return 'message'
      }
    },
    reportID: function () {
      return this.reportObject.id
    },
    body: function () {
      return `To report ${this.reportedObjectUserName}'s ${this.reportType}`
    },
    help: function () {
      return this.showText ? false : i18n.t('projectPage.report')
    },
    showText: function () {
      return this.project || this.post
    },
    reportedObjectUserName: function () {
      if (this.project || this.post || this.comment) {
        return this.reportObject.user.userName
      }
      if (this.message) {
        return this.reportObject.sender.userName
      }
    },
    isOwner: function () {
      if (this.project) {
        return this.project.user.userName === this.currentUser.userName
      } else if (this.post) {
        return this.post.user.userName === this.currentUser.userName
      } else if (this.comment) {
        return this.comment.user.userName === this.currentUser.userName
      } else if (this.message) {
        return this.message.sender.userName === this.currentUser.userName
      }
    },
    tooltipDirection: function () {
      return this.tooltipDir ? this.tooltipDir : 'up'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.report {
  &-header {
    font-size: 0.7rem;
    color: $grey-dark;
    font-weight: 500;
    padding-left: 0.75rem;
  }
  &:hover {
    color: $primary;
  }
  &:focus {
    border: 1px solid $primary;
  }
}
</style>
